import {singleBold} from './bold';
import type FontFamilyStyles from './types';

const fontFamily: FontFamilyStyles = {
    EXP_NEUE_ITALIC: 'ExpensifyNeue-Italic',
    EXP_NEUE_BOLD: singleBold,
    EXP_NEUE: 'ExpensifyNeue-Regular',
    EXP_NEW_KANSAS_MEDIUM: 'ExpensifyNewKansas-Medium',
    EXP_NEW_KANSAS_MEDIUM_ITALIC: 'ExpensifyNewKansas-MediumItalic',
    SYSTEM: 'System',
    MONOSPACE: 'ExpensifyMono-Regular',
    MONOSPACE_ITALIC: 'ExpensifyMono-Regular',
    MONOSPACE_BOLD: 'ExpensifyMono-Bold',
    MONOSPACE_BOLD_ITALIC: 'ExpensifyMono-Bold',
};

export default fontFamily;
